import { Guid, Nillable } from '@web/utils';
import { Multimedia } from '@web/shared/module/multimedia';
import { PublicProductCharacteristic } from './public-product-characteristic';
import { PublicProductAttribute } from './public-product-attribute';
import { PublicProductCosmeticBrand } from './public-product-cosmetic-brand';
import { PublicSales } from '@web/shared/module/shop';

export class PublicProductDetails {
  public constructor(
    private readonly data: {
      attributes: PublicProductAttribute[];
      characteristics: PublicProductCharacteristic[];
      cosmeticBrand?: Nillable<PublicProductCosmeticBrand>;
      files: Multimedia[];
      id: Guid;
      name: string;
      slug: string;
      vendorUrl?: Nillable<string>;
      sales: PublicSales;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get vendorUrl(): Nillable<string> {
    return this.data.vendorUrl;
  }

  public get cosmeticBrand(): Nillable<PublicProductCosmeticBrand> {
    return this.data.cosmeticBrand;
  }

  public get files(): Multimedia[] {
    return this.data.files;
  }

  public get characteristics(): PublicProductCharacteristic[] {
    return this.data.characteristics;
  }

  public get attributes(): PublicProductAttribute[] {
    return this.data.attributes;
  }

  public get sales(): PublicSales {
    return this.data.sales;
  }
}
